import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "../../styles/Login.css";
import loginImg from "../../assets/loginImage.jpeg";
import LoadingComponent from "../../components/common/Loading";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Navbar from "../../layouts/Navbar";
import logo from "../../assets/Logo.png";
import api from "../../api/config";
import { Link } from "react-router-dom";

function UpdatePassword() {
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

 
   


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      password.trim() === "" ||
      newPassword.trim() === "" ||
      confirmPassword.trim() === ""
    ) {
      toast.error("Please fill in all fields.");
      return;
    }

    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
    if (!passwordRegex.test(newPassword, confirmPassword, password)) {
      toast.error("Password must be at least 8 characters long and contain both letters and numbers");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match.");
      return;
    }

    try {
      setLoading(true);
      // Make API request to update password
      
      const response = await api.post(
        "https://yelospace.com/api/user-update-password",
        {
          password,
          confirmPassword,
          newPassword,
        },
       
      );

      if (response.data.status === 200) {
        toast.success("Password Updated Successfully !")
        setTimeout(() => {
          navigate('/');
       
        }, 2500);
      } else {
        toast.error("Current Password is incorrect.");
      }
    } catch (error) {
      console.error("Error occurred:", error);
      toast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>

      <ToastContainer />
      <Navbar/>
      <div className="login-container">
   
        <div className="left-panel mt-5 py-3">
          <img src={loginImg} alt="Left Panel Image" />
        </div>
        <div className="right-panel mt-5 py-5">
        <div className="w-100 d-flex justify-content-center">
   <Link to="/">
      <img src={logo} className="logo-img" alt="Left Panel Image" />
   </Link>
</div>
          <h3>Change Password</h3>
          <form className="w-100" onSubmit={handleSubmit}>
            <div className="password-input-container">
              <label htmlFor="currentPassword">Current Password</label>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="form-control w-75 mx-auto mt-3 p-2"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ background: "rgba(217, 217, 217, 0.60)" }}
              />
              <span
                className="password-toggle-btn2"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? (
                  <FontAwesomeIcon icon={faEyeSlash} />
                ) : (
                  <FontAwesomeIcon icon={faEye} />
                )}
              </span>
            </div>

            <div className="password-input-container">
              <label htmlFor="newPassword">New Password</label>
              <input
                type={showPassword ? "text" : "password"}
                name="newPassword"
                className="form-control w-75 mx-auto mt-3 p-2"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                style={{ background: "rgba(217, 217, 217, 0.60)" }}
              />
              <span
                className="password-toggle-btn2"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? (
                  <FontAwesomeIcon icon={faEyeSlash} />
                ) : (
                  <FontAwesomeIcon icon={faEye} />
                )}
              </span>
            </div>

            <div className="password-input-container">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type={showPassword ? "text" : "password"}
                name="confirmPassword"
                className="form-control w-75 mx-auto mt-3 p-2"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={{ background: "rgba(217, 217, 217, 0.60)" }}
              />
              <span
                className="password-toggle-btn2"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? (
                  <FontAwesomeIcon icon={faEyeSlash} />
                ) : (
                  <FontAwesomeIcon icon={faEye} />
                )}
              </span>
            </div>

            <div className="w-100 d-flex justify-content-center">
              <button
                type="submit"
                disabled={loading}
                className="login-btn mx-auto"
              >
                {loading ?"Processing": "Change Password"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default UpdatePassword;
